import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import ReactGA from "react-ga4";
import RegisterHeader from "./Common/Header";
import GroupIcon from '@mui/icons-material/Group';
import CurrencyExchangeIcon from '@mui/icons-material/CurrencyExchange';
import LocalCarWashIcon from '@mui/icons-material/LocalCarWash';
import "./Register.scss";

const RegisterExplanation = () => {
  const navigate = useNavigate();

  const handleContinue = () => {
    ReactGA.event("explanation_continue_click", {
      event: 'explanation_continue_click',
      button_id: 'explanation_continue',
      page_path: window.location.pathname
    });
    navigate("/register/survey");
  };

  return (
    <div style={{ 
      minHeight: '100vh', 
      backgroundColor: '#f8fafc',
      paddingTop: 'clamp(100px, 10vw, 150px)',
      color: '#0f172a',
      display: 'flex',
      flexDirection: 'column'
    }}>
      <RegisterHeader />
      
      {/* Header / Hero */}
      <header style={{ 
        position: 'relative',
        overflow: 'hidden',
        backgroundColor: 'white'
      }}>
        <div style={{
          position: 'absolute',
          inset: 0,
          background: 'linear-gradient(90deg, rgba(37, 99, 235, 0.05) 0%, rgba(14, 165, 233, 0.05) 100%)'
        }}></div>
        <div style={{ 
          position: 'relative',
          maxWidth: '1280px', 
          margin: '0 auto', 
          padding: '0 16px 20px'
        }}>
          <div style={{ textAlign: 'center', maxWidth: '1024px', margin: '0 auto' }}>
            <div style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '8px',
              padding: '8px 16px',
              backgroundColor: '#dbeafe',
              color: '#1d4ed8',
              borderRadius: '9999px',
              fontSize: '0.875rem',
              fontWeight: '500',
              marginBottom: '0px'
            }}>
              <span>⭐</span>
              Seja um Parceiro WashPass
            </div>
            
            <h1 style={{ 
              fontSize: 'clamp(1.875rem, 4vw, 3.75rem)', 
              fontWeight: 'bold', 
              lineHeight: 1.1,
              marginBottom: '24px',
              letterSpacing: '-0.025em'
            }}>
              No WashPass, <span style={{ color: '#2563eb' }}>a lavagem é só o começo</span>
            </h1>
            
            <p style={{ 
              marginTop: '24px', 
              fontSize: 'clamp(1.125rem, 2vw, 1.25rem)', 
              color: '#64748b', 
              maxWidth: '768px',
              margin: '24px auto 0',
              lineHeight: 1.6
            }}>
              Você recebe clientes recorrentes e vende os serviços que dão margem. O repasse funciona como seu <strong style={{ color: '#0f172a' }}>CAC (Custo de aquisição de cliente)</strong>: um investimento para atrair o cliente certo. <strong style={{ color: '#2563eb' }}>O lucro está no que vem depois.</strong>
            </p>
            
            <div style={{ 
              marginTop: '32px', 
              display: 'flex',
              flexWrap: 'wrap',
              justifyContent: 'center',
              gap: '16px'
            }}>
              <div style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: '8px',
                padding: '8px 16px',
                backgroundColor: '#dbeafe',
                color: '#1e40af',
                borderRadius: '9999px',
                fontWeight: '500'
              }}>
                <span>👥</span> Clientes recorrentes
              </div>
              <div style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: '8px',
                padding: '8px 16px',
                backgroundColor: '#dcfce7',
                color: '#166534',
                borderRadius: '9999px',
                fontWeight: '500'
              }}>
                <span>✨</span> Upsell garantido
              </div>
              <div style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: '8px',
                padding: '8px 16px',
                backgroundColor: '#f3e8ff',
                color: '#7c3aed',
                borderRadius: '9999px',
                fontWeight: '500'
              }}>
                <span>📈</span> ROI comprovado
              </div>
            </div>
          </div>
        </div>
      </header>

      {/* Content */}
      <main style={{ flex: 1 }}>
        {/* Como Funciona */}
        <section style={{ 
          maxWidth: '1280px', 
          margin: '0 auto', 
          padding: '5px 16px 46px'
        }}>
          <div style={{ textAlign: 'center', marginBottom: '64px' }}>
            <h2 style={{ 
              fontSize: 'clamp(1.875rem, 3vw, 2.25rem)', 
              fontWeight: 'bold',
              marginBottom: '16px'
            }}>
              Como funciona na prática
            </h2>
            <p style={{ 
              fontSize: '1.125rem', 
              color: '#64748b', 
              maxWidth: '512px',
              margin: '0 auto'
            }}>
              Um processo simples que transforma visitantes em clientes fiéis
            </p>
          </div>

          <div style={{ 
            display: 'grid', 
            gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', 
            gap: '32px' 
          }}>
            <StepCard 
              number="01"
              icon={<GroupIcon style={{ fontSize: '5rem' }} />}
              title="Nós atraímos o cliente"
              description="O motorista assina o WashPass e encontra sua loja pelo app. Marketing e aquisição por nossa conta."
              color="#2563eb"
            />
            <StepCard 
              number="02"
              icon={<LocalCarWashIcon style={{ fontSize: '5rem' }} />}
              title="Você faz a lavagem simples"
              description="Recebe o valor de repasse conforme a categoria escolhida. Serviço padronizado e rápido."
              color="#059669"
            />
            <StepCard 
              number="03"
              icon={<CurrencyExchangeIcon style={{ fontSize: '5rem' }} />}
              title="Você vende o que dá margem"
              description="Higienização, polimento, selantes, cristalização. Aqui está o seu verdadeiro lucro."
              color="#7c3aed"
            />
          </div>
        </section>


        {/* Limite de Uso */}
        <section style={{ 
          background: 'linear-gradient(90deg, #fffbeb 0%, #fed7aa 100%)',
          padding: '44px 0 96px',
          textAlign: 'left',
        }}>
          <div style={{ 
            maxWidth: '1280px', 
            margin: '0 auto', 
            padding: '0 16px',
            display: 'grid', 
            gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', 
            gap: '48px', 
            alignItems: 'start' 
          }}>
            <div>
              {/* Tag dentro do bloco amarelo */}
              <div style={{ 
                display: 'inline-flex', 
                alignItems: 'center', 
                gap: '8px', 
                padding: '8px 16px', 
                backgroundColor: '#fef3c7', 
                color: '#92400e', 
                borderRadius: '9999px', 
                fontSize: '0.875rem', 
                fontWeight: '500', 
                marginBottom: '8px' 
              }}>
                <span style={{ fontSize: '1rem' }}>⚠️</span>
                Política de Uso Justo
              </div>
              
              <h3 style={{ 
                fontSize: 'clamp(1.5rem, 3vw, 1.875rem)', 
                fontWeight: 'bold',
                color: '#0f172a',
                marginBottom: '16px'
              }}>
                Até 4 lavagens por mês, por cliente
              </h3>
              <p style={{ 
                marginTop: '16px', 
                color: '#64748b', 
                fontSize: '1.125rem',
                lineHeight: 1.6,
                marginBottom: '24px'
              }}>
                Limitamos o repasse a <strong>até 4 lavagens mensais</strong> por cliente. A partir daí, o valor diminui
                progressivamente. Isso evita abusos e mantém o modelo saudável — atraindo clientes que valorizam seu
                trabalho.
              </p>
              
              {/* Card branco separado */}
              <div style={{ 
                backgroundColor: 'white', 
                border: '1px solid #fbbf24', 
                borderRadius: '12px', 
                padding: '16px',
                marginTop: '24px'
              }}>
                <div style={{ 
                  display: 'flex', 
                  alignItems: 'flex-start', 
                  gap: '12px'
                }}>
                  <div style={{
                    padding: '8px',
                    backgroundColor: '#fef3c7',
                    borderRadius: '8px'
                  }}>
                    <span style={{ fontSize: '1.25rem', color: '#f59e0b' }}>⚡</span>
                  </div>
                  <div>
                    <h4 style={{ fontWeight: '600', color: '#0f172a', marginBottom: '4px' }}>Proteção do Parceiro</h4>
                    <p style={{ fontSize: '0.875rem', color: '#64748b' }}>
                      Suspeita de uso indevido? Nossa equipe investiga e protege a rentabilidade do seu negócio.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div 
              className="explanation-chart-card"
              style={{ 
                backgroundColor: 'white', 
                border: '1px solid #e2e8f0', 
                borderRadius: '16px', 
                padding: '24px',
                boxShadow: '0 4px 6px rgba(0, 0, 0, 0.05)'
              }}>
              <div style={{ 
                fontSize: 'clamp(1rem, 2vw, 1.125rem)', 
                fontWeight: '600',
                color: '#0f172a',
                marginBottom: '20px'
              }}>
                Repasse por lavagem no mês
              </div>
              <div style={{ marginTop: '12px' }}>
                {[
                  { label: "1ª à 4ª lavagem", value: 100 },
                  { label: "5ª à 6ª lavagem", value: 50 },
                  { label: "7ª à 8ª lavagem", value: 25 },
                  { label: "9ª em diante", value: 10 },
                ].map((b, i) => (
                  <div key={i} style={{ 
                    display: 'flex', 
                    alignItems: 'center', 
                    gap: '16px', 
                    marginBottom: '16px' 
                  }}>
                    <div style={{ 
                      width: '120px', 
                      fontSize: 'clamp(0.875rem, 2vw, 1rem)', 
                      color: '#64748b',
                      fontWeight: '500'
                    }}>
                      {b.label}
                    </div>
                    <div style={{ 
                      flex: 1, 
                      backgroundColor: '#f1f5f9', 
                      borderRadius: '9999px', 
                      height: '16px',
                      overflow: 'hidden'
                    }}>
                      <div
                        style={{ 
                          height: '16px', 
                          borderRadius: '9999px', 
                          backgroundColor: i < 4 ? '#1976d2' : '#94a3b8',
                          width: `${b.value}%`,
                          transition: 'all 0.3s ease'
                        }}
                      />
                    </div>
                    <div style={{ 
                      width: '60px', 
                      textAlign: 'right', 
                      fontSize: 'clamp(0.875rem, 2vw, 1rem)', 
                      color: '#64748b',
                      fontWeight: '600'
                    }}>
                      {b.value}%
                    </div>
                  </div>
                ))}
              </div>
              <div style={{ 
                marginTop: '16px', 
                fontSize: '0.75rem', 
                color: '#64748b',
                fontStyle: 'italic'
              }}>
                *Percentuais ilustrativos para demonstrar a redução após a 4º lavagem mensal.
              </div>
            </div>
          </div>
        </section>

        {/* FAQ */}
        <section style={{ 
          backgroundColor: 'white',
          padding: '44px 0 96px'
        }}>
          <div style={{ 
            maxWidth: '1024px', 
            margin: '0 auto', 
            padding: '0 16px' 
          }}>
            <div style={{ textAlign: 'center', marginBottom: '48px' }}>
              <h3 style={{ 
                fontSize: 'clamp(1.5rem, 3vw, 1.875rem)', 
                fontWeight: 'bold',
                marginBottom: '16px'
              }}>
                Perguntas frequentes
              </h3>
              <p style={{ 
                fontSize: '1.125rem', 
                color: '#64748b'
              }}>
                Esclarecemos as principais dúvidas dos parceiros
              </p>
            </div>
            <div style={{ 
              display: 'flex', 
              flexDirection: 'column', 
              gap: '16px',
              textAlign: 'left'
            }}>
              <FaqItem q="Qual categoria devo escolher?" a="Se busca volume e oportunidades de upsell, comece em Flex/Pro. Se sua operação é premium e quer tickets maiores por visita, considere Elite/Ultra." />
              <FaqItem q="Posso mudar de categoria depois?" a="Sim! Você pode ajustar o repasse sempre que precisar, conforme sazonalidade e capacidade da sua loja." />
              <FaqItem q="O que é uma lavagem simples?" a="Lavagem com sabão externa, secagem externa com pano e higienização externa simples. Serviços a parte podem ser contratados diretamente com o estabelecimento." />
              <FaqItem q="Como e quando recebo o pagamento?" a="O Pagamento é feito após validação de lavagens mensal e emissão da nota fiscal." />
            </div>
          </div>
        </section>
      </main>

      {/* CTA Final */}
      <footer style={{ 
        position: 'sticky',
        bottom: 0,
        zIndex: 10,
        borderTop: '1px solid #e2e8f0',
        backgroundColor: 'rgba(255, 255, 255, 0.95)',
        backdropFilter: 'blur(8px)'
      }}>
        <div style={{ 
          maxWidth: '1280px', 
          margin: '0 auto', 
          padding: '16px 16px'
        }}>
          <div style={{ 
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: '16px'
          }}>
            <div style={{ textAlign: 'center' }}>
              <p style={{ 
                fontWeight: '600', 
                color: '#0f172a',
                fontSize: '1rem',
                margin: '0 0 4px 0'
              }}>
                Entendeu como funciona?
              </p>
              <p style={{ 
                color: '#64748b',
                fontSize: '0.875rem',
                margin: '0'
              }}>
                Agora escolha sua categoria e defina seu repasse.
              </p>
            </div>
            <button 
              onClick={handleContinue}
              style={{ 
                display: 'inline-flex',
                alignItems: 'center',
                gap: '8px',
                padding: '12px 24px',
                borderRadius: '12px',
                fontWeight: '600',
                textTransform: 'none',
                fontSize: '1rem',
                background: 'linear-gradient(90deg, #2563eb 0%, #0ea5e9 100%)',
                color: 'white',
                border: 'none',
                cursor: 'pointer',
                transition: 'opacity 0.2s',
                boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
              }}
              onMouseOver={(e) => (e.target as HTMLButtonElement).style.opacity = '0.9'}
              onMouseOut={(e) => (e.target as HTMLButtonElement).style.opacity = '1'}
            >
              Escolher Minha Categoria →
            </button>
          </div>
        </div>
        
        <div style={{ textAlign: 'center', marginTop: '32px', marginBottom: '16px' }}>
          <p style={{ 
            color: '#64748b',
            fontSize: '1rem',
            margin: 0
          }}>
            Ficou alguma dúvida?{" "}
            <a 
              href="/fale-conosco" 
              style={{ 
                color: '#1976d2', 
                textDecoration: 'none',
                fontWeight: '500'
              }}
              onMouseEnter={(e) => e.currentTarget.style.textDecoration = 'underline'}
              onMouseLeave={(e) => e.currentTarget.style.textDecoration = 'none'}
            >
              Fale Conosco
            </a>
          </p>
        </div>
      </footer>
    </div>
  );
};

function StepCard({ number, icon, title, description, color }: { 
  number: string; 
  icon: React.ReactNode; 
  title: string; 
  description: string; 
  color: string; 
}) {
  return (
    <div style={{ 
      position: 'relative',
      backgroundColor: 'white', 
      borderRadius: '16px', 
      border: '1px solid #e2e8f0', 
      padding: '32px', 
      boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)'
    }}>
      {/* Número no topo esquerdo */}
      <div style={{
        position: 'absolute',
        top: '-26px',
        left: '32px'
      }}>
        <div style={{
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: '51px',
          height: '51px',
          backgroundColor: '#0f172a',
          color: 'white',
          fontSize: '1.4rem',
          fontWeight: 'bold',
          borderRadius: '50%'
        }}>
          {number}
        </div>
      </div>
      
      {/* Ícone */}
      <div style={{ 
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '48px',
        height: '48px',        
        color: color,
        marginBottom: '16px'
      }}>
        <span style={{ fontSize: '24px' }}>{icon}</span>
      </div>
      
      {/* Título */}
      <h3 style={{ 
        fontSize: '1.25rem',
        fontWeight: 'bold',
        color: '#0f172a',
        marginBottom: '12px'
      }}>
        {title}
      </h3>
      
      {/* Descrição */}
      <p style={{ 
        color: '#64748b',
        lineHeight: 1.6
      }}>
        {description}
      </p>
    </div>
  );
}



function FaqItem({ q, a }: { q: string; a: string }) {
  const [open, setOpen] = useState(false);
  return (
    <div style={{ 
      backgroundColor: 'white', 
      border: '1px solid #e2e8f0', 
      borderRadius: '16px', 
      padding: '16px' 
    }}>
      <button 
        onClick={() => setOpen((v) => !v)} 
        style={{ 
          width: '100%', 
          textAlign: 'left', 
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'space-between', 
          gap: '12px',
          border: 'none',
          background: 'none',
          cursor: 'pointer'
        }}
      >
        <span style={{ fontWeight: '600' }}>{q}</span>
        <svg 
          style={{ 
            height: '16px', 
            width: '16px', 
            transition: 'transform 0.2s',
            transform: open ? 'rotate(180deg)' : 'rotate(0deg)'
          }} 
          viewBox="0 0 20 20" 
          fill="currentColor"
        >
          <path d="M5.23 7.21a.75.75 0 011.06.02L10 10.94l3.71-3.71a.75.75 0 111.06 1.06l-4.24 4.24a.75.75 0 01-1.06 0L5.21 8.29a.75.75 0 01.02-1.08z" />
        </svg>
      </button>
      {open && (
        <p style={{ 
          marginTop: '8px', 
          fontSize: 'clamp(0.875rem, 2vw, 1rem)', 
          color: '#64748b',
          lineHeight: 1.5,
          paddingLeft: '8px'
        }}>
          {a}
        </p>
      )}
    </div>
  );
}

export default RegisterExplanation;